// SSM emits a 0–5 severity. The CameraView renders badge buckets; map the numeric
// scale onto them. Out-of-range values are clamped to the nearest bucket.
//
// 3 gets its own bucket rather than sharing "medium" with 2: severity 3 is where the
// Guard starts raising alerts, so the two must never share a color — the line between
// "we logged it" and "we texted the owner" has to be visible at a glance (2026-07-24).

export type SeverityBucket = "critical" | "high" | "elevated" | "medium" | "low";

export const SEVERITY_RANK: Record<SeverityBucket, number> = {
  critical: 5,
  high: 4,
  elevated: 3,
  medium: 2,
  low: 1,
};

export const severityBucket = (severity: number): SeverityBucket => {
  if (severity >= 5) return "critical";
  if (severity >= 4) return "high";
  if (severity >= 3) return "elevated";
  if (severity >= 2) return "medium";
  return "low";
};
